import { useEffect, useRef, useContext } from 'react'
import _ from 'lodash'
import usePrevious from 'hooks/usePrevious'
import { sagaActions } from '../sagas'
import { useDispatch } from 'react-redux'
import ChannelsContext from 'contexts/ChannelsContext'
import { runSaga } from 'store/sagaMiddleware'
import layoutChannelData from '../sagas/layoutChannelData'

export default function useLayoutsData (layoutIds) {
  const channelDataSagaByIdRef = useRef({})

  const dispatch = useDispatch()

  const prevLayoutIds = usePrevious(layoutIds)

  const {
    addChannel,
    removeChannel
  } = useContext(ChannelsContext)

  useEffect(() => {
    const addedLayoutIds = _.difference<number>(layoutIds, prevLayoutIds)
    const removedLayoutIds = _.difference<number>(prevLayoutIds, layoutIds)

    if (addedLayoutIds.length > 0) {
      const actions: any[] = []

      addedLayoutIds.forEach(layoutId => {
        channelDataSagaByIdRef.current[layoutId] = runSaga(layoutChannelData, layoutId)

        addChannel(`homeLayout-${layoutId}`, () => {})

        actions.push(sagaActions.fetchHomeLayout({ layoutId }))
      })

      if (actions.length > 0) {
        dispatch(actions)
      }
    }

    if (removedLayoutIds.length > 0) {
      removedLayoutIds.forEach(layoutId => {
        channelDataSagaByIdRef.current[layoutId].cancel()
        delete channelDataSagaByIdRef.current[layoutId]

        removeChannel(`homeLayout-${layoutId}`)
      })
    }
  }, [layoutIds])
}
